import containerFuild from '../html-snippets/container-fuild.js';
import css from '../css-snippets/section-upairy-card.js';
import buttonPrimary from '@/views/website/products/components/description/ui-modules/button-primary/raw-html.js';

const DEFAULT_IMAGE = 'https://cdn.skyfastimg.com/images/2026/08/06/image-6a74036a3db831797c4c6406.webp?w=1000';

const defaultItems = [
  {
    title: `<h2><span style="color:hsl( 110, 39%, 41% );"><strong>1st Week</strong></span></h2>`,
    description: `<p>Most parents report visible progress.</p>`,
  },
  {
    title: `<h2><span style="color:hsl( 110, 39%, 41% );"><strong>2-3</strong></span></h2>`,
    description: `<p>weeks <strong>typical </strong>potty training time.</p>`,
  },
  {
    title: `<h2><span style="color:hsl( 110, 39%, 41% );"><strong>100k+</strong></span></h2>`,
    description: `<p>families and counting</p>`,
  },
];

const buttonHtml = buttonPrimary({
  backgroundColor: '#4B963E',
  color: '#FFFFFF',
  radius: 16,
  text: '👉 START POTTY TRAINING TODAY',
  iconPrefix: { show: false, src: '' },
  iconSuffix: { show: false, src: '' },
  subBtn: { show: false, text: '' },
});

const renderItem = item => `
  <div class="upairy-card__item" data-attribute="upairy-card__item">
    <div class="upairy-card__item-title" data-attribute="upairy-card__item-title">${item.title}</div>
    <div class="upairy-card__item-description" data-attribute="upairy-card__item-description">${item.description}</div>
  </div>
`;

const contentHtml = `
  <div
    class="upairy-card container"
    data-attribute="upairy-card"
    data-image-show="true"
    data-image-position="left"
  >
    <div class="upairy-card__layout" data-attribute="upairy-card__layout">
      <div class="upairy-card__image" data-attribute="upairy-card__image">
        <img
          loading="lazy"
          data-attribute="upairy-card__image-element"
          src="${DEFAULT_IMAGE}"
          alt="Child wearing UpAiry training underwear"
        />
      </div>
      <div class="upairy-card__content" data-attribute="upairy-card__content">
        <div class="upairy-card__header" data-attribute="upairy-card__header">
         <h2 style="text-align:center;"><strong>Potty Train In Weeks, Not Months</strong></h2>
          <p>UpAiry Training Underwear uses <em>Feel-Learn™</em> technology to help your child recognize their body's signals – the key to faster potty training success.</p>
        </div>
        <div class="upairy-card__list" data-attribute="upairy-card__list">
          ${defaultItems.map(renderItem).join('')}
        </div>
        <div class="upairy-card__button" data-attribute="upairy-card__button">
          ${buttonHtml}
        </div>
        <div class="upairy-card__footer" data-attribute="upairy-card__footer">
          <p style="text-align:center;"><strong>🕓 LIMITED TIME OFFER •</strong> FREE EBOOK &amp; STICKER CHART</p>
        </div>
      </div>
    </div>
  </div>
`;

export default containerFuild(contentHtml, css);
